// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1A7CA","content":"Consent_content__1Avqb","footer":"Consent_footer__scNOc"};